module.exports = __webpack_public_path__ + "media/application/images/icons/worth-considering-3d7c6dc4a2122bf4ee340486863542bd.svg";